import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=2fb1f71d&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fb1f71d')) {
      api.createRecord('2fb1f71d', component.options)
    } else {
      api.reload('2fb1f71d', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=2fb1f71d&", function () {
      api.rerender('2fb1f71d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8LF8uzFnt2MuK/JS/comp/childrenage.vue"
export default component.exports